/**
 * Manuals index filter (sections/bc-manuals-index.liquid). Progressive
 * enhancement: without JS every card shows and the filter box stays hidden.
 * Matches every whitespace-separated term against the card's `data-search`
 * (title + covered product titles + search_text, lowercased server-side).
 */
class BcManualsIndex extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-bc-manuals-filter]');
    this.input = this.querySelector('[data-bc-manuals-input]');
    if (!this.bar || !this.input) return;
    this.cards = Array.from(this.querySelectorAll('[data-bc-manuals-card]'));
    this.count = this.querySelector('[data-bc-manuals-count]');
    this.empty = this.querySelector('[data-bc-manuals-empty]');
    this.bar.hidden = false;
    this.input.addEventListener('input', () => this.apply());
    this.apply();
  }

  apply() {
    const terms = this.input.value.toLowerCase().split(/\s+/).filter(Boolean);
    let shown = 0;
    for (const card of this.cards) {
      const hay = card.dataset.search || '';
      const hit = terms.every((t) => hay.includes(t));
      card.hidden = !hit;
      if (hit) shown++;
    }
    if (this.empty) this.empty.hidden = shown > 0;
    if (this.count) {
      this.count.textContent = terms.length
        ? shown === 1 ? '1 manual' : `${shown} manuals`
        : '';
    }
  }
}

if (!customElements.get('bc-manuals-index')) customElements.define('bc-manuals-index', BcManualsIndex);
